import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportInterventionsRealtimeReportComponent } from './transport-interventions-realtime-report.component';
import {DxLoadPanelModule, DxPopupModule} from 'devextreme-angular';
import {MapLayersControlModule} from '../../map/map-layers-control/map-layers-control.module';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import { TransportInterventionsRealtimeReportDetailsComponent } from './transport-interventions-realtime-report-details/transport-interventions-realtime-report-details.component';
import {BadgeModule} from 'shared';



@NgModule({
  declarations: [TransportInterventionsRealtimeReportComponent, TransportInterventionsRealtimeReportDetailsComponent],
  imports: [
    CommonModule,
    DxPopupModule,
    DxLoadPanelModule,
    MapLayersControlModule,
    LeafletModule,
    BadgeModule
  ],
  exports: [TransportInterventionsRealtimeReportComponent]
})
export class TransportInterventionsRealtimeReportModule { }
